package dev.terrakok.mapitan.domain.geojson

import androidx.compose.ui.graphics.Color
import dev.terrakok.mapitan.domain.Document
import dev.terrakok.mapitan.domain.DocumentObject
import dev.terrakok.mapitan.domain.Pin
import dev.terrakok.mapitan.domain.utils.toHexRgb
import kotlinx.serialization.json.JsonObject
import kotlinx.serialization.json.JsonPrimitive
import kotlinx.serialization.json.buildJsonObject
import org.maplibre.compose.sources.GeoJsonData
import org.maplibre.spatialk.geojson.Feature
import org.maplibre.spatialk.geojson.FeatureCollection
import org.maplibre.spatialk.geojson.Point


data class PinDrag(val pinId: String, val point: Point)

fun DocumentObject?.pinSelectionGeoJson(drag: PinDrag? = null): GeoJsonData = GeoJsonData.Features(
    FeatureCollection(
        if (this is Pin) {
            listOf(
                Feature(
                    geometry = if (drag?.pinId == id) drag.point else point,
                    properties = buildJsonObject { }
                )
            )
        } else {
            emptyList()
        }
    )
)

private fun pinFeature(
    pointId: String,
    point: Point,
    color: Color,
): Feature<Point, JsonObject> = Feature(
    geometry = point,
    properties = buildJsonObject {
        put(MapKeys.MAPITAN_ID_PROPERTY, JsonPrimitive(pointId))
        put(MapKeys.COLOR_PROPERTY, JsonPrimitive(color.toHexRgb()))
    },
)

fun Document.pinsGeoJson(drag: PinDrag? = null): GeoJsonData = GeoJsonData.Features(
    FeatureCollection(
        pins.map { pin ->
            pinFeature(pin.id, if (drag?.pinId == pin.id) drag.point else pin.point, pin.color)
        }
    )
)